import buildRoutes from 'ember-engines/routes';
export default buildRoutes(function () {
  this.route('landing');
  this.route('registry', {
    path: ''
  }, function () {
    this.route('buckets', function () {
      this.route('bucket', {
        path: '/:bucket_name'
      }, function () {
        this.route('versions', function () {
          this.route('version', {
            path: '/:fingerprint'
          }, function () {
            this.route('revoke');
            this.route('build', {
              path: '/builds/:build_id'
            });
          });
        });
        this.route('channels', function () {
          this.route('channel', {
            path: '/:channel_name'
          }, function () {
            this.route('history');
          });
        });
        this.route('hcl-snippet');
      });
    });
    this.route('settings', function () {
      this.route('pricing');
      this.mount('monitoring', {
        as: 'monitoring'
      });
    });
  });
});